module.exports = __webpack_public_path__ + "images/9ee669b4fde94debc73dbd80ec8c24b1.svg";